import { NavLink } from "react-router-dom";
import { useState } from "react";

const Navbar = () => {
    const [navbarIsActive, setNavbarIsActive] = useState(false)
    const menus = [
        {
            id: 1,
            name: 'Youtube',
            slug: '',
        },
    ]
    const toggleNavbar = () => {
        setNavbarIsActive(!navbarIsActive)
    }

    return (
        <nav className="bg-gray-800">
            <div className="max-w-7xl mx-auto px-2 sm:px-6 lg:px-8">
                <div className="relative flex items-center justify-between h-16">
                    <div className="absolute inset-y-0 left-0 flex items-center sm:hidden">
                        <button type="button" className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white" aria-controls="mobile-menu" aria-expanded="false">
                            <span className="sr-only">Open main menu</span>
                            <svg onClick={toggleNavbar} className={`${!navbarIsActive ? 'block' : 'hidden'} h-6 w-6`} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
                            </svg>
                            <svg onClick={toggleNavbar} className={`${navbarIsActive ? 'block' : 'hidden'} h-6 w-6`} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>
                    <div className="flex-1 flex items-center justify-center sm:items-stretch sm:justify-start">
                        <div className="flex-shrink-0 flex items-center">
                            <NavLink to="/" className="text-white uppercase">Kazanfar</NavLink>
                        </div>
                        <div className="hidden sm:block sm:ml-6">
                            <div className="flex space-x-4">
                                {menus.map(item => (
                                    <NavLink key={item.id} to={`/${item.slug}`} activeClassName="bg-gray-900" className="text-gray-300 hover:bg-gray-700 text-white px-3 py-2 rounded-md text-sm font-medium" aria-current="page">{item.name}</NavLink>
                                ))}
                                <a target="_blank" href="https://fermanallahverdiev.com" className="block text-gray-300 hover:bg-gray-700 text-white px-3 py-2 rounded-md text-base font-medium">Me</a>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className={`sm:hidden ${navbarIsActive ? 'block' : 'hidden'}`} id="mobile-menu">
                <div className="px-2 pt-2 pb-3 space-y-1">
                    {menus.map(item => (
                        <NavLink key={item.id} to={`/${item.slug}`} activeClassName="bg-gray-900 text-white" className="block text-gray-300 hover:bg-gray-700 text-white px-3 py-2 rounded-md text-base font-medium" aria-current="page">{item.name}</NavLink>
                    ))}
                    <a target="_blank" href="https://fermanallahverdiev.com" className="block text-gray-300 hover:bg-gray-700 text-white px-3 py-2 rounded-md text-base font-medium">Me</a>
                </div>
            </div>
        </nav>
    )
}
export default Navbar
